<div class="phone-completion">
  <div class="phone-completion__badge">
    <ion-icon name="call-outline"></ion-icon>
  </div>

  <h3 class="phone-completion__title">
    {{ "MODALS.PHONE_COMPLETION.TITLE" | translate }}
  </h3>

  <p class="phone-completion__message">
    {{ "MODALS.PHONE_COMPLETION.MESSAGE" | translate }}
  </p>

  <div class="phone-completion__field" [formGroup]="form">
    <app-phone-field
      formControlName="phone_field"
      [submitted]="submitted"
      [role]="role"
      [required]="true"
      [usePrefix]="false"
    >
    </app-phone-field>
  </div>

  <p *ngIf="serverError" class="phone-completion__error">
    {{ serverError }}
  </p>

  <button
    class="phone-completion__cta"
    type="button"
    [disabled]="loading"
    (click)="submit()"
  >
    <app-spinner *ngIf="loading"></app-spinner>
    <span *ngIf="!loading">{{ "MODALS.PHONE_COMPLETION.CTA" | translate }}</span>
  </button>
</div>
